<div class="checkout-section section-active" id="delivery-address-section">
  <p class="section-subtitle">{{ (isPickperson ? 'checkoutPickup.sectionSubtitle' :
  'checkoutDeliveryAddress.sectionSubtitle') | cxTranslate }}</p>
  <div class="delivery-radius-message">
    We deliver within 300 miles of our Emerson, GA facility.
  </div>
  <form [formGroup]="deliveryAddressForm" (ngSubmit)="onSubmit()">
    <div class="form-row">
      <div class="form-group" [ngClass]="{'has-error': isInvalid('firstName')}">
        <label for="first-name">{{'checkoutPickup.form.firstName' | cxTranslate}} <span class="required">*</span></label>
        <input id="first-name" class="form-input" maxlength="30" formControlName="firstName" required>
        <cx-form-errors [control]="deliveryAddressForm.get('firstName')"></cx-form-errors>
      </div>

      <div class="form-group" [ngClass]="{'has-error': isInvalid('lastName')}">
        <label for="last-name">{{'checkoutPickup.form.lastName' | cxTranslate}} <span class="required">*</span></label>
        <input id="last-name" maxlength="30" class="form-input" formControlName="lastName" required>
        <cx-form-errors [control]="deliveryAddressForm.get('lastName')"></cx-form-errors>
      </div>
    </div>

    <div class="form-group full-width" [ngClass]="{'has-error': isInvalid('phoneNumber')}">
      <label for="phone-number">{{'checkoutPickup.form.phoneNumber' | cxTranslate}} <span class="required">*</span></label>
      <input id="phone-number" class="form-input" formControlName="phoneNumber" (input)="formatPhoneNumber()">
      <cx-form-errors [control]="deliveryAddressForm.get('phoneNumber')"></cx-form-errors>
    </div>

    @if (!isPickperson) {
      <div>
        <div class="form-group full-width" [ngClass]="{ 'has-error': isInvalid('line1') }">
          <label for="delivery-address">{{'checkoutDeliveryAddress.form.line1' | cxTranslate}}
            <span class="required">*</span></label>
            <input id="delivery-address" maxlength="45" class="form-input" formControlName="line1" required>
            <cx-form-errors [control]="deliveryAddressForm.get('line1')"></cx-form-errors>
          </div>
          <div class="form-group full-width">
            <label for="address-line-2">{{'checkoutDeliveryAddress.form.line2' | cxTranslate}}
              <span>(optional)</span></label>
              <input maxlength="30" id="address-line-2" class="form-input" formControlName="line2">
            </div>
            <div class="form-row">
              <div class="form-group" [ngClass]="{ 'has-error': isInvalid('city') }">
                <label for="city">{{'checkoutDeliveryAddress.form.city' | cxTranslate}} <span class="required">*</span></label>
                <input maxlength="30" id="city" class="form-input" formControlName="city" required>
                <cx-form-errors [control]="deliveryAddressForm.get('city')"></cx-form-errors>
              </div>
              <div class="form-group" [ngClass]="{ 'has-error': isInvalid('state') }">
                <label for="state">{{'checkoutDeliveryAddress.form.state' | cxTranslate}} <span class="required">*</span></label>
                <ng-select id="state" [items]="stateData" bindLabel="name" bindValue="isocode" formControlName="state" placeholder="" formControlName="state">
                </ng-select>
                <cx-form-errors [control]="deliveryAddressForm.get('state')"></cx-form-errors>
              </div>
            </div>
            <div class="form-group full-width" [ngClass]="{ 'has-error': isInvalid('zipCode')}">
              <label for="zip-code">{{'checkoutDeliveryAddress.form.zipCode' | cxTranslate}} <span class="required">*</span></label>
              <input id="zip-code" class="form-input" (blur)="validateZip()" maxlength="5" formControlName="zipCode" required>
              <cx-form-errors [control]="deliveryAddressForm.get('zipCode')"></cx-form-errors>
            </div>
            @if (showInvalidZipcodeMsg) {
              <span class="zip-error-message">This location is not within our delivery radius.</span>
            }
          </div>
        }

        <div class="d-flex justify-content-end">
          <button type="submit" class="continue-btn"
          [disabled]="!deliveryAddressForm.valid || showInvalidZipcodeMsg">{{'checkoutPickup.continueButton' | cxTranslate}} </button>
        </div>
      </form>
    </div>